import { createProviderWithoutThrowing } from "src/common/factories/createProvider.tsx";

export const {
  Provider: ControlLabelV2Provider,
  useContext: useControlLabelV2Context,
} = createProviderWithoutThrowing<{
  id?: string;
  disabled?: boolean;
} | null>(null, "ControlLabelV2");
